<div class="wrapper-modal">
  <form [formGroup]="createOrEditUserExperienceForm" (ngSubmit)="submitUserExperienceForm()" class="wrapper-content-modal">
    <div class="header-modal">
      <span class="title-modal">{{userExperienceForEdit ? 'Izmeni korisničko iskustvo' : 'Kreiraj korisničko iskustvo'}}</span>
    </div>
    <div class="content-modal">
      <div class="wrapper-input">
        <span class="label-input">Korisnik</span>
        <div class="zc-input">
          <input type="text" [formControl]="createOrEditUserExperienceForm.controls.author | formControl" [placeholder]="'Naziv kosinsika'">
        </div>
        <span class="error-message">{{createOrEditUserExperienceForm.controls.author | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">Opis recenzije</span>
        <div class="zc-textarea">
          <textarea type="text" [formControl]="createOrEditUserExperienceForm.controls.description | formControl" [placeholder]="'Upišite opis recenzije'"></textarea>
        </div>
        <span class="error-message">{{createOrEditUserExperienceForm.controls.description | formControlErrorMessages: null: formTriedToSubmit}}</span>
      </div>
      <div class="xs-mb-20">
        <div class="label-banner">
          <span>Ubacite sliku korisnika</span>
        </div>
        <div class="wrapper-custom-gallery banners">
          <div *ngIf="!imageUrl" class="header-custom-gallery">
            <div class="wrapper-btn-gallery">
              <div class="file-input">
                <label class="file-input__label2">
                  <span>Dodaj Sliku</span>
                  <input #fileInput class="file-input__input" type="file" accept=".jpg,.jpeg,.png,.svg" (change)="onFileChange($event)"/>
                </label>
              </div>
            </div>
            <span class="error-message">{{createOrEditUserExperienceForm.controls.image | formControlErrorMessages: null : formTriedToSubmit}}</span>
          </div>
          <div *ngIf="imageUrl" class="content-custom-gallery-banner">
            <div class="wrapper-gallery-image-banner">
              <img [src]="imageUrl" alt="banner-image">
              <div class="overlay-delete" (click)="removeFile()">
                <i class="fa-solid fa-xmark"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-modal">
      <button type="button" (click)="closeModal.emit()" class="zc-btn zc-btn--gray"><span>Izađi</span></button>
      <button type="submit" class="zc-btn zc-btn--primary"><span>{{userExperienceForEdit ? 'Izmeni' : 'Dodaj'}}</span></button>
    </div>
  </form>
</div>
